module.exports = __webpack_public_path__ + "static/img/wechatpay.77db497d.svg";